import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup,FormControl, Validators } from '@angular/forms';
import {Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../services/api.service';
import { UsersService } from '../../services/users.service';
import { NgxSpinnerService } from "ngx-spinner";
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import getMAC, { isMAC } from 'getmac'
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  submitted = false;
  hide=true;
  IP_address:any='';
  rdoUserTyp = new FormControl('');
  
  errorInfo:{isError:boolean,errorMsg:string} = {isError:false,errorMsg:''}
  data={};
  constructor(private modalService: NgbModal,private http: HttpClient,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    public auth: ApiService,
    private spinner: NgxSpinnerService,
    private authUser:UsersService
  ) { 
    
  }
  loginForm = new FormGroup({
		email: new FormControl('', [Validators.required, Validators.email,
      Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
		password: new FormControl('', Validators.required),
	});
  open1(content: any) { 
    this.modalService.open(content, { centered: true, size: 'sm', backdrop: 'static', keyboard: false }); 
  }
  open(content: any) { 
    this.submitted = true;
    //localStorage.clear();
    localStorage.removeItem('userLoginPass');
    if(this.loginForm.invalid)
    {
      return;
    }
    this.modalService.open(content, { centered: true, size: 'sm', backdrop: 'static', keyboard: false }); 
  }
  ngOnInit(): void {
    this.rdoUserTyp.setValue("1");
    // var macaddress = require('macaddress');
    // macaddress.one(function (err:any, mac) {
    //   console.log("Mac address for this host: %s", mac);  
    // });
    //console.log(getMAC())
    // if (localStorage.getItem('userLoginData') !='') {
    //   this.router.navigateByUrl('/assigned'); 
    // }
    
    this.getIPAddress();
  }
  
  getIPAddress()
  {  
    this.http.get("https://jsonip.com/").subscribe((res:any)=>{
      this.IP_address = res.ip;
    },
    (error)=>{
     // console.log(error);
    });
    
  }
// convenience getter for easy access to form fields
get f() { return this.loginForm.controls; }
	
loginUser(loginForm:any)
{
  this.submitted = true;
  localStorage.clear();
 // localStorage.removeItem('userLoginPass');
  if(this.loginForm.invalid)
  {
    return;
  }
  var data1 = {'email': this.loginForm.value.email,'pass': this.loginForm.value.password};
  localStorage.setItem('userLoginPass', JSON.stringify(data1));
  this.spinner.show();
  if (this.rdoUserTyp.value == "1") {
    this.auth.user_login(this.loginForm.value, this.IP_address).subscribe(
      (data) => {
        document.getElementById('closelId')?.click();
        if (data.success) {
          if (data.data.is_account_valid == 1) {
            var date2 = new Date();
            var date1 = new Date(data.data.created_dttm);
            date1.setMonth(date1.getMonth() + 6);
            var Time = date2.getTime() - date1.getTime();
            var Days = Time / (1000 * 3600 * 24);
            if (Days > 0) {
              document.getElementById('AcoountValidation')?.click();
              this.spinner.hide();
            } else {
              localStorage.setItem('userLoginData', JSON.stringify(data.data));
              this.authUser.authSet(data.data, this.loginForm.value.email, this.loginForm.value.password);
              this.router.navigateByUrl('/assigned');
              //this.router.navigateByUrl('/assigned');
              this.spinner.hide();
            }
          } 
          else {
            localStorage.setItem('userLoginData', JSON.stringify(data.data));
            this.authUser.authSet(data.data, this.loginForm.value.email, this.loginForm.value.password);
            this.router.navigateByUrl('/assigned');
            //this.router.navigateByUrl('/assigned');
            this.spinner.hide();
          }
        } else if (data.error) {
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = data.error;
          this.spinner.hide();
        } else {
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'Incorrect email or password';
          this.spinner.hide();
        }
      },
      (error) => {
        this.errorInfo.isError = true;
        this.errorInfo.errorMsg = error;
        this.spinner.hide();
      },
    );
  }
  else if (this.rdoUserTyp.value == "2") {
    this.router.navigateByUrl('/admin-login')
  }
 
}
goToForgot(){
  this.router.navigate(['/forgot'], { queryParams: { status: 1 } });
}
}
